// extracted by mini-css-extract-plugin
export var chip = "_fy-0";
export var filterDropdown = "_fy-5";
export var filterItem = "_fy-6";
export var icon = "_fy-1";
export var removeButton = "_fy-3";
export var removeIcon = "_fy-4";
export var separator = "_fy-2";